import React, { useState, useEffect } from 'react';

interface WaveLoaderProps {
  size?: 'sm' | 'md' | 'lg' | 'xl';
  className?: string;
  isVisible?: boolean;
}

const sizeMap = {
  sm: 12,
  md: 20,
  lg: 32,
  xl: 48,
};

export const WaveLoader: React.FC<WaveLoaderProps> = ({ size = 'md', className = '', isVisible = true }) => {
  const dimension = sizeMap[size];
  const [shouldRender, setShouldRender] = useState(isVisible);
  const [animationClass, setAnimationClass] = useState(isVisible ? 'animate-fade-in' : '');

  useEffect(() => {
    if (isVisible) {
      setShouldRender(true);
      setAnimationClass('animate-fade-in');
    } else {
      setAnimationClass('animate-fade-out');
      const timer = setTimeout(() => {
        setShouldRender(false);
      }, 300); // Match animation duration
      return () => clearTimeout(timer);
    }
  }, [isVisible]);

  if (!shouldRender) return null;

  return (
    <div
      className={`flex items-center justify-center ${animationClass} ${className}`}
      style={{ width: dimension, height: dimension }}
    >
      <img
        src="/loader-icon.png"
        alt="Loading..."
        className="animate-spin-slow"
        style={{
          width: '100%',
          height: '100%',
          objectFit: 'contain',
        }}
      />
    </div>
  );
};

export default WaveLoader;
